import React from 'react';
import Image from 'react-bootstrap/Image';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash-es';

import DefaultOrgLogo from '../../../../../assets/images/DefaultOrgLogo.svg';

import DescriptionField from './DescriptionField/DescriptionField';

import styles from './CandidateDescription.module.scss';

const CandidateDescription = ({
  jobName = '',
  organizationName = '',
  logoUrl,
  candidateName = '',
  candidateEmail = '',
  referedBy = '',
}) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.rootContainer}>
      <div>
        <DescriptionField>
          <div className={styles.organizationContainer}>
            <div className={styles.flexDisplay}>
              <Image src={logoUrl ?? DefaultOrgLogo} alt="logo" className={styles.logo} />
            </div>
            <div className={styles.candidateContainer}>
              <span className={styles.jobName}>{jobName}</span>
              <span className={styles.organizationName}>{organizationName}</span>
            </div>
          </div>
        </DescriptionField>
      </div>

      <div>
        <DescriptionField placeHolder={t('candidateDescription.candidateInformation')}>
          <div className={styles.candidateContainer}>
            <span className={styles.candidateName}>{candidateName}</span>
            <span className={styles.candidateEmail}>{candidateEmail}</span>
          </div>
        </DescriptionField>
      </div>

      {!isEmpty(referedBy) && (
        <div>
          <DescriptionField placeHolder={t('candidateDescription.referralProvider')}>
            <div className={styles.referedBy}>{referedBy}</div>
          </DescriptionField>
        </div>
      )}
    </div>
  );
};

export default CandidateDescription;
